import React, { Component } from 'react';
import queryString from 'query-string';
import './App.scss';
import { getComponents } from './utils/constant';
import { getRequestData } from './utils/util';

import componentsInfo1 from './config/config.1.json';
import componentsInfo2 from './config/config.2.json';

// 配置模版模块
const componentsInfo = {
  "1": componentsInfo1,
  "2": componentsInfo2,
}

function getElementTop(el) {

  var actualTop = el.offsetTop
  var current = el.offsetParent

  while (current !== null) {
    actualTop += current.offsetTop
    current = current.offsetParent

  }
  return actualTop

}

export default class App extends Component {
  
  constructor(props) {
    super(props);
    const urlParams = getRequestData() || {};
    const version = urlParams.v || 1;
    const config = (typeof window !== 'undefined') ?
      (window.INIT_DATA || props.initState || componentsInfo[version]) : (props.initState);
    this.state = {
      config: config
    }

  }

  scrollToElement = (id) => {
    id = id || this.getCurEditElementId()
    if(!id) return;
    const curEditElement = document.getElementById(id);
    if (!curEditElement) return
    const scrollHeight = getElementTop(curEditElement)
    window.scrollTo(0,scrollHeight)
  }
  componentDidMount() {
    // window.addEventListener('message', ({data}) => {
    //   const {id} = data
    //   this.scrollToElement(id)
    // })
    // this.scrollToElement()

    window.onload=() => {
      this.scrollToElement()
    }
    
    window.onhashchange = () => {
      this.scrollToElement()
    }
  }

  getCurEditElementId() {
    return queryString.parse(window.location.hash).id
  }
  
  render() {
    const Components = getComponents(this.state.config);
    return <React.Fragment>{Components}</React.Fragment>
  }
}


